import { JobResponse } from '@doda/api-client/aspida/@types';
import { makeArticleSummary } from './makeArticleSummary';
import { makeCorporateFullName } from './makeCorporateFullName';

/**
 * 記事要約と会社フルネームを取得し、テキストを返却する
 * @param {JobResponse} job
 * @param tabState
 * @returns AltText
 */
export const makePickupImageAltText = (job: JobResponse, tabState?: string) =>
  `${makeArticleSummary(job, tabState)}${makeCorporateFullName(job)}`;
